import { ThemeProvider } from "@mui/material";
import PageTemplate from "../../components/common/particles.jsx/PageTemplate";
import HOC from "../../components/HOC";
import { theme } from "../../components/constants/muiTheme";
import SfaList from "../../components/screen/Sfa/SfaList";

const SfaApprovalPage = () => {
  return (
    <PageTemplate
      mainComponent={
        <ThemeProvider theme={theme}>
          <SfaList />
        </ThemeProvider>
      }
      pageRole={3}
      header="OLISA Approval"
    />
  );
};

export default HOC(SfaApprovalPage);
